enum ContractUserType {
  CONTRACTOR = 0,
  PRIMARY = 1,
  SECONDARY = 2,
}

export const key = (type: ContractUserType | undefined | null) => {
  switch (type) {
    case ContractUserType.CONTRACTOR:
      return 'contractor';
    case ContractUserType.PRIMARY:
      return 'primary';
    case ContractUserType.SECONDARY:
      return 'secondary';
    default:
      return 'user';
  }
};

export const name = (type: ContractUserType | undefined | null) => {
  switch (type) {
    case ContractUserType.CONTRACTOR:
      return ['user', 0];
    case ContractUserType.PRIMARY:
      return ['user', 1];
    case ContractUserType.SECONDARY:
      return ['user', 2];
    default:
      return ['user', 3];
  }
};

export const title = (type: ContractUserType | undefined | null) => {
  switch (type) {
    case ContractUserType.CONTRACTOR:
      return '임차인';
    case ContractUserType.PRIMARY:
      return '제1운전자';
    case ContractUserType.SECONDARY:
      return '제2운전자';
    default:
      return '';
  }
};

export default ContractUserType;
